import {styled} from '@linaria/react';
import React from 'react';
import {BaseProductTileProps} from '../BaseProductTile/BaseProductTile';
import {ProductTileWrapper} from '../BaseProductTile/ProductTileWrapper';
import {InteractiveProductTileBase} from './InteractiveProductTile';

export const InteractiveSliderProductTileBase: React.FC<
  React.PropsWithChildren<BaseProductTileProps>
> = props => {
  return (
    <StyledInteractiveProductTileBase {...props} disableProductGalleryMode />
  );
};

const StyledInteractiveProductTileBase = styled(InteractiveProductTileBase)`
  --defaultHeight: 100%;
  --bottomSpacing: 8px;

  &[data-interactive='true'] {
    > div,
    ${ProductTileWrapper} {
      height: 100%;
    }
  }
`;
